module.exports = __webpack_public_path__ + "static/img/AC.6468b829.svg";